import { render, staticRenderFns } from "./VideoRequest.vue?vue&type=template&id=73d754d0&scoped=true&"
import script from "./VideoRequest.vue?vue&type=script&lang=js&"
export * from "./VideoRequest.vue?vue&type=script&lang=js&"
import style0 from "./VideoRequest.vue?vue&type=style&index=0&id=73d754d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d754d0",
  null
  
)

export default component.exports